import React from 'react';

const BtcDominanceIndicator = ({ dominance }) => {
  return (
    <div className="flex items-center">
      <span className="mr-2 font-medium" title="Bitcoin Dominance">BTC.D:</span>
      <span className="font-bold">
        <a 
          href="https://www.tradingview.com/chart/?symbol=CRYPTOCAP%3ABTC.D"
          target="_blank"
          rel="noopener noreferrer"
        >
          {dominance?.toFixed(1) || 'N/A'}%
        </a>
      </span>
    </div>
  );
};

export default BtcDominanceIndicator; 